<script>
    import All from './All';

    export default {
        extends: All,
        name: 'Paginate',
        props: {
            action: {},
            query: {
                type: Object,
                default: () => ({})
            },
            replace: {
                type: Boolean,
                default: true
            },
            page:{
                type: Number,
                default:1
            },
            propKey:{
                type: String,
                default:''
            },
            reset: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                meta: null
            };
        },
        watch:{
            page(n,o){
                if (this.immediate) {
                    this.request();
                }
            },
            reset(){
                this.localData = []
            }

        },
        methods: {
            async request() {
                
                try {
                    this.loading = true;

                    const model = await this.getModel();
                    let query={...this.query}
                    if(this.page>1){
                         query= {...query, page: this.page}
                    }
                    const { data, meta } = await model.paginate({

                        query: query,
                        ...this.config
                    });

                    if (this.replace) {
                        this.localData = [];
                    }
                    let requestData = []
                    if(this.propKey) {
                        requestData = data[this.propKey];    
                    } else {
                        requestData = data;                        
                    }
                    
                    this.localData.push(...requestData); 

                    this.meta = meta;


                    this.$emit('update:data', this.localData);
                    this.$emit('success', {data:this.localData,cont:requestData.length});
                } catch (error) {
                    console.log('PAGINATE ERROR:',error);
                    this.error = error;
                } finally {
                    this.loading = false;
                }
            },

        },
        computed: {
            slotProps() {
                return {
                    request: this.request,
                    loading: this.loading,
                    data: this.localData,
                    meta: this.meta,
                    reset: this.reset
                };
            }
        },
    }
</script>

<style scoped>

</style>